/**
 * Location Edit - gas station features fields
 *
 * @author Naiqiao Liang (nliang@yext.com)
 */
goog.provide('yext.location.GasStationFeatures');
goog.provide('yext.location.GasStationFeaturesView');

/**
 * Gas station features data model
 * @constructor
 * @param {!Array<Object>} allGasStationFeatures
 */
yext.location.GasStationFeatures = function(allGasStationFeatures) {
  this.allGasStationFeatures = allGasStationFeatures || {};
  this.originalAllGasStationFeatures = $.extend(true, [], this.allGasStationFeatures);
};

/**
 * @param {string}  feature  Gas station feature
 * @param {boolean} selected Whether feature is selected
 */
yext.location.GasStationFeatures.prototype.update = function(feature, selected) {
  this.allGasStationFeatures[feature] = selected;
};


/**
 * Revert model to its original status.
 */
yext.location.GasStationFeatures.prototype.reset = function() {
  this.allGasStationFeatures = $.extend(true, [], this.originalAllGasStationFeatures);
};

/**
 * Gas station features view model
 *
 * @constructor
 */
yext.location.GasStationFeaturesView = function($ctx) {
  this.$ctx = $ctx;

  this.prepareViewModel(this.$ctx);
  this.init();
};

yext.location.GasStationFeaturesView.prototype.init = function() {
  this.bindSelectFeatures();
  this.prepareIndeterminate();
};

yext.location.GasStationFeaturesView.prototype.bindSelectFeatures = function() {
  var $featureInputs = this.$ctx.find('input');
  var that = this;

  $featureInputs.on('change', function() {
    that.message('update');
    that.model.update($(this).attr('name'), $(this).prop('checked'));
  });
};

yext.location.GasStationFeaturesView.prototype.prepareIndeterminate = function() {
  this.$ctx.find('.indeterminate').prop('indeterminate', true);
};

/**
 * Prepare data model for gas station feature view from the html.
 */
yext.location.GasStationFeaturesView.prototype.prepareViewModel = function() {
  var allFeatures = this.$ctx.data('model');
  this.model = new yext.location.GasStationFeatures(allFeatures);
};

/**
 * Revert view to its original status.
 */
yext.location.GasStationFeaturesView.prototype.reset = function() {
  this.model.reset();
  this.renderViewMode();
  this.renderEditMode();
};

/**
 * @param {string} message The message name
 * @param {!Object} data Optional data attached to the message
 */
yext.location.GasStationFeaturesView.prototype.message = function(message, data) {
  $(this).trigger(message, data);
};

/**
 * Render view mode.
 */
yext.location.GasStationFeaturesView.prototype.renderViewMode = function() {
  var $empty = this.$ctx.find('.emptyvalue');
  var $various = this.$ctx.find('.various');
  var $features = this.$ctx.find('.features');

  var allGasStationFeatures = this.model.allGasStationFeatures;
  var prettyNames = [];
  var hasIndeterminate = false;

  for (var i = 0; i < allGasStationFeatures.length; i ++) {
    if (allGasStationFeatures[i].selected) {
      prettyNames.push(allGasStationFeatures[i].translateName);
    }
    if (allGasStationFeatures[i].indeterminate) {
      hasIndeterminate = true;
    }
  }

  $various.toggle(hasIndeterminate);
  $empty.toggle(prettyNames.length == 0 && !hasIndeterminate);
  $features.html(prettyNames.join(', '))
    .toggle(prettyNames.length > 0 && !hasIndeterminate);
};

/**
 * Render edit mode.
 */
yext.location.GasStationFeaturesView.prototype.renderEditMode = function() {
  var allGasStationFeatures = this.model.allGasStationFeatures;

  for (var i = 0; i < allGasStationFeatures.length; i ++) {
    var $checkbox = $('#gasStationFeatures\\.'+allGasStationFeatures[i].fieldName);

    $checkbox.prop('checked', allGasStationFeatures[i].selected);
    if (allGasStationFeatures[i].indeterminate) {
      $checkbox.addClass('indeterminate');
    }
  }
};
